import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/home/success.svg'


const _withScopeId = n => (_pushScopeId("data-v-edf116c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialogvisible-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = { class: "content-title" }
const _hoisted_4 = { class: "content-table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialogVisible) = $event)),
    title: "",
    width: "500px",
    "destroy-on-close": "",
    center: "",
    "show-close": false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        loading: _ctx.loading,
        class: "content-confirm",
        onClick: _ctx.confirm,
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode("确定")
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title) + "已提交", 1),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_scrollbar, { class: "scroll-wrapper" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tradingData, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "table-th",
                  key: index
                }, [
                  _createElementVNode("span", null, _toDisplayString(item.nameCn) + " (" + _toDisplayString(item.fundAccount) + ")", 1),
                  _createElementVNode("span", {
                    class: "status",
                    style: _normalizeStyle(
                item?.info?.ok || item?.resp?.ok
                  ? 'color:#000'
                  : 'color:#FF414E'
              )
                  }, _toDisplayString(item?.info?.ok || item?.resp?.ok
                  ? `${_ctx.title}已提交`
                  : `${_ctx.title}失败(${item?.info?.reason?.desc})`), 5)
                ]))
              }), 128))
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}